<template>
    <span class="artist" v-if="simpleText">{{instrumentString == "" ? "No artist": instrumentString}}</span>
    <span v-else-if="displayBagdes" class="instrument-badge-container" @click.prevent="onClick">
        <span v-if="instruments != null" v-for="instrument in instruments" :key="instrument.name" class="badge instrument-badge">
          <span class="name">{{instrument.name}}</span>
        </span>
    </span>
    <input v-else type="text" readonly placeholder="Instruments" :value="instrumentString" :class="!instrumentString || instrumentString.length === 0 ? 'is-empty' : ''" @click.prevent="onClick"/>
</template>

<script>
    export default {
      name: "InstrumentsBadgeList",
      props: {
        instruments: Array,
        displayBagdes: { type: Boolean, default: false },
        simpleText: { type: Boolean, default: false }
      },
      computed: {
        instrumentString() {
          console.log(this.instruments)
          if (!this.instruments || this.instruments.length === 0) {
            return '';
          }

          var instrumentsName = this.instruments.map(x =>  x.name);
          return instrumentsName.join(', ');
        }
      },
        methods: {
        onClick(event) { this.$emit("click", event); }
      }
    }
</script>

<style scoped>
    .instrument-badge-container {
        white-space: nowrap;
        text-overflow: ellipsis;
        border-bottom: 1px solid #d2d2d2;
        height: 30px;
        display: block;
    }

    .instrument-badge-container:hover {
        border-bottom: 1px solid #18B9E7;
        cursor: pointer;
    }

    .instrument-badge {
        background: #18B9E7;
        border-radius: 100px;
        display: -webkit-inline-box;
        display: -ms-inline-flexbox;
        display: inline-flex;
        padding: 5px 10px;
        color: white;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        margin: 0 5px;
    }

    .instrument-badge.hidden {
        background: #d2d2d2;
    }

    .instrument-badge .name {
        width: 100%;
        display: block;
        overflow: hidden;
        text-overflow: ellipsis;
        margin: 0 1em;
    }

    input[type=text] {
        text-overflow: ellipsis;
        cursor: pointer;
    }

    input [type=text]:focus {
        background: transparent;
    }
</style>
